import React, { useState } from "react";
import { Input } from "components/Form";
import { Button } from "components/Button/Button";
import { verifyMobile, adminInvoiceGeneration } from "services/student/studentController";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import toast from "react-hot-toast";

const AdminInvoiceGeneration = () => {
    const [newData, setNewData] = useState({
        search: "",
    });
    const [errorField, setErrorField] = useState({
        search: "",
    });
    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewData({ ...newData, [name]: value });
    };

    const handleValidation = () => {
        let errorField = {};
        let formIsValid = true;

        if (!newData.search) {
            errorField["search"] = "Please Enter User Email Address or Phone";
            formIsValid = false;
        }
        setErrorField(errorField);
        return formIsValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setSubmitLoading(true);
            try {
                const finalData = {
                    search: newData.search,
                };
                const res = await adminInvoiceGeneration(finalData);

                if (res.code === 200 && res.data?.sURL) {
                    toast.success("Invoice Generated Successfully.");
                    downloadFile(res.data.sURL);
                    setNewData({ search: "" });
                    setErrorField({ search: "" });
                }else if(res.message === "Cannot read properties of null (reading 'dataValues')"){
                    toast.error("Please enter valid Email Address or Phone");
                } else {
                    toast.error(res.message);
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
            } finally {
                setSubmitLoading(false);
            }
        }
    };

    const downloadFile = (url) => {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Invoice.pdf"); // You can set a default name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <>
            <div className="WrapperBox">
                <div className="Small-Wrapper">
                    <div className="search_wrap" >
                        <div className="SearchBox"></div>
                        <h4 className="Title">Admin Invoice Generation</h4>
                    </div>
                    <div className="row mt-1">
                        <div className="col-form-label py-0 col-md-10">
                            <form onSubmit={handleSubmit}>
                                <div className="form-group row mt-1">
                                    <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                                        <div className="row">
                                            <div className="col-sm-4 col-form-label">
                                                <Input
                                                    type="text"
                                                    name="search"
                                                    value={newData.search}
                                                    onChange={handleChange}
                                                    placeholder="Enter Transaction ID"
                                                    className={`form-control`}
                                                    maxLength={110}
                                                    //   label={"Mobile Number"}
                                                    error={errorField.search}
                                                //   required
                                                />
                                            </div>
                                            <div className="col-sm-4 col-form-label">
                                                <Button
                                                    type="submit"
                                                    className="mx-2"
                                                    loading={submitButtonElement.loading}
                                                >
                                                    Generate Invoice
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <hr className="border border-danger" />
                </div>
            </div>
        </>
    );
};

export default AdminInvoiceGeneration;
